import { SliceErrorState } from '@/store/slices/sliceError';

export type RecentlyPlayedItem = {
  gameId?: string;
  gameUid?: string;
  prismicCode?: string;
  displayName?: string;
  imagePath?: string;
  providerName?: string;
  providerRef?: string;
  providerRefMobile?: string;
  providerRefDesktop?: string;
  rgi?: string;
  gameLaunchCode?: string;
};

/** Domain data (mirrors GeolocationContext-style split). */
export type RecentlyPlayedContext = {
  recentlyPlayed: Array<RecentlyPlayedItem> | null;
  nextGameId: string | null;
  nextGameUid: string | null;
  nextGameUrl: string | null;
};

export type RecentlyPlayedStatus = {
  loading: boolean;
};

export enum RecentlyPlayedStoreParts {
  recentlyPlayedContext = 'recentlyPlayedContext',
  recentlyPlayedStatus = 'recentlyPlayedStatus',
  /** Separate from root `error` (geolocation) */
  recentlyPlayedError = 'recentlyPlayedError',
}

export type RecentlyPlayedContextPayload = Partial<RecentlyPlayedContext>;
export type RecentlyPlayedStatusPayload = Partial<RecentlyPlayedStatus>;
export type RecentlyPlayedErrorPayload = Partial<SliceErrorState>;

export type RecentlyPlayedSlice = {
  recentlyPlayedContext: RecentlyPlayedContext;
  recentlyPlayedStatus: RecentlyPlayedStatus;
  recentlyPlayedError: SliceErrorState;

  setRecentlyPlayedContext: (newState: RecentlyPlayedContextPayload) => void;
  setRecentlyPlayedStatus: (newState: RecentlyPlayedStatusPayload) => void;
  setRecentlyPlayedError: (newState: RecentlyPlayedErrorPayload) => void;
  resetRecentlyPlayedPart: (part: RecentlyPlayedStoreParts) => void;
  resetAllRecentlyPlayedParts: () => void;
};
